import { observable, action } from "mobx";
import { persist } from "mobx-persist";
import SporterModel from "containers/testselection/store/model/SporterModel";
import TestModel from "containers/testselection/store/model/TestModel";
import TestProgressModel from "./TestProgressModel";
import flattenArray from "utils/flattenArray";
import {forEach} from "underscore";

export default class SporterTestModel {
  @persist
  @observable
  id;

  @persist("object", SporterModel)
  @observable
  sporter;

  @persist("object", TestModel)
  @observable
  test;

  @persist("object", TestProgressModel)
  @observable
  testProgress;

  @persist("object")
  data;

  constructor(id, sporter, test, trials) {
    this.id = id;
    this.sporter = sporter;
    this.test = test;
    this.testProgress = new TestProgressModel(trials);
  }

  @action
  createTestProgress(trials) {
    this.testProgress = new TestProgressModel(trials);
  }

  @action
  setProgress(data) {
    this.testProgress.setResult(data);
  }

  getSaveData() {
    const resultSet = this.testProgress.getResult();
    const laterality = this.data.test.testItems[0].sides;
    const lateralityValue = flattenArray(Object.entries(laterality))[0];
    const data = {}

    forEach(resultSet, (trial) => {
        forEach(Object.keys(trial), (key) => {
          data[key] = data[key] || {};
          data[key][key] = data[key][key] || {};
          data[key][key][lateralityValue] = data[key][key][lateralityValue] || [];
          data[key][key][lateralityValue].push(Number(trial[key]));
        });
    });

    return {
      sporter: this.sporter,
      data,
    };
  }

  toJS() {
    return {
      id: this.id,
      sporter: this.sporter.toJS(),
      test: this.test.toJS(),
      testProgress: this.testProgress.toJs(),
    };
  }
}
